export default {
  token: [
    {
      key: "required",
      message: "Verifieringskod är obligatoriskt.",
      id: "tokenRequired",
    },
  ],
};
